import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCallinScriptList extends Layout {
    buttonCopyCallinScript: Button;
    layoutheaderCallinScriptList: LayoutHeader;
    sourceCallinScriptTemplate: DataSource;
    tableCallinScriptTemplateList: Table;
}
